import axios from "axios";
import { Notification, MessageBox, Message, Loading } from "element-ui";
import { saveAs } from "file-saver";
import errorCode from "@/utils/errorCode";
import { Base64 } from 'js-base64';
// 全局加载指示器实例
let downloadLoadingInstance;

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
  },
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 实时获取最新token
    const token = localStorage.getItem("Authorization");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const code = response.data.code || 200;
    const msg = errorCode[code] || response.data.msg || errorCode["default"];
    // 处理二进制数据
    if (
      response.config.responseType === "blob" ||
      response.config.responseType === "arraybuffer"
    ) {
      return response.data;
    }

    switch (code) {
      case 401:
        if (!isRelogin.show) {
          isRelogin.show = true;
          MessageBox.confirm("登录状态已过期，请重新登录", "系统提示", {
            confirmButtonText: "重新登录",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              isRelogin.show = false;
              // 这里添加重新登录逻辑
            })
            .catch(() => {
              isRelogin.show = false;
            });
        }
        return Promise.reject("无效的会话，或会话已过期，请重新登录。");
      case 500:
        Message({ message: msg, type: "error" });
        return Promise.reject(new Error(msg));
      case 601:
        Message({ message: msg, type: "warning" });
        return Promise.reject("error");
      default:
        if (code !== 200) {
          Notification.error({ title: msg });
          return Promise.reject("error");
        }
        return response.data;
    }
  },
  (error) => {
    let { message } = error;
    if (message === "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = `系统接口${message.substr(message.length - 3)}异常`;
    }
    Message({ message, type: "error", duration: 5 * 1000 });
    return Promise.reject(error);
  }
);

/**
 * 通用文件下载方法
 * @param {string} url 请求地址
 * @param {object} params 请求参数
 * @param {string} filename 下载文件名
 * @param {object} config axios配置项
 * @param {Boolean} isPreview 是否需要预览
 * 
 */
export function downloadFile(url,params = {},filename = "file",config = {}) {
  downloadLoadingInstance = Loading.service({
    text: "正在下载数据，请稍候",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
  });

  // 处理请求方法
  const method = (config.method || "POST").toUpperCase();
  const requestConfig = {
    url,
    method,
    responseType:config.isPreview?null: "blob",
    ...config,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded", // 默认值
      ...config.headers,
    },
  };

  // 处理参数位置
  if (method === "GET") {
    requestConfig.params = params;
  } else {
    requestConfig.data = params;

    // 自动处理参数转换
    if (!requestConfig.headers["Content-Type"].includes("application/json")) {
      requestConfig.transformRequest = [tansParams];
    }
  }

  return service(requestConfig)
    .then(async (data) => {
      
      const isValidBlob = blobValidate(data);
        // =============== 新增预览逻辑 ===============

        if (config.isPreview) {
          if(isValidBlob) return Message.error("该文件暂时不支持预览");
          console.log(data,'666666666666');
          this.$filePerview(data.data,filename );//预览

        } else {
          if(isValidBlob){
              // 正常下载
              saveAs(new Blob([data]), filename);
          }else{
            // blob中是后端返回的JSON错误信息，解析出msg
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const result = JSON.parse(reader.result);
                Message.error(result.msg || "下载失败");
              } catch (e) {
                Message.error("下载失败",e);
              }
            };
            reader.readAsText(data);
          }
        
        }

    })
    .catch((err) => {
      console.error(config.isPreview ? "文件预览错误:" : "文件下载错误:", err);
      Message.error(
        config.isPreview ? "文件预览失败，请联系管理员" : "文件下载失败，请联系管理员"
      );
    })
    .finally(() => {
      downloadLoadingInstance?.close();
    });
}

/**
 * 参数序列化处理
 * @param {object} params 参数对象
 * @returns {string}
 */
export function tansParams(params) {
  let result = "";
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    if (value === null || value === "" || typeof value === "undefined")
      continue;

    if (typeof value === "object") {
      for (const key of Object.keys(value)) {
        const subValue = value[key];
        if (
          subValue === null ||
          subValue === "" ||
          typeof subValue === "undefined"
        )
          continue;
        result += `${encodeURIComponent(propName)}[${key}]=${encodeURIComponent(
          subValue
        )}&`;
      }
    } else {
      result += `${encodeURIComponent(propName)}=${encodeURIComponent(value)}&`;
    }
  }
  return result.slice(0, -1); // 移除最后一个&
}

/**
 * 验证是否为有效的Blob
 * @param {any} data 待验证数据
 * @returns {boolean}
 */
export function blobValidate(data) {
  try {
    return data instanceof Blob && data.type !== "application/json";
  } catch (e) {
    return false;
  }
}


export default service;
